import React from 'react';
import {Button} from 'reactstrap'

class HealthcalculatorBtn extends React.Component{
  render(){
    return(
        <div style={{margin:"0 auto"}} className="mt-5 pb-5 text-center">
          <a href={`${process.env.REACT_APP_HOST}/${this.props.link}`} target="_blank">
            <Button className="healthCalculatorBtn">Go to Calculator</Button>
          </a>
          {this.props.isPdf && 
          <Button className="healthCalculatorBtn" onClick={this.props.generatePdf}>Download PDF</Button>
          }
        </div>
    );

  }
}


export default HealthcalculatorBtn


// WEBPACK FOOTER //
// ./src/views/HealthTools/HealthcalculatorBtn.js